import { useState } from 'react';
import { useToast } from '../../hooks/use-toast';
import { clientService } from '../../api';

export const useDocActions = (onChanged) => {
  const { toast } = useToast();
  const [busyItem, setBusyItem] = useState(null);
  const fail = (title) => (e) => toast({ title, description: e?.response?.data?.detail || 'Try again.', variant: 'destructive' });

  const toggle = (req) => (item) => {
    const next = item.status === 'received' ? 'missing' : 'received';
    return clientService.setItemStatus(req.clientId, req.id, item.id, next).then((r) => onChanged?.(r)).catch(fail('Update failed'));
  };
  const upload = (req) => (item, file) => {
    setBusyItem(item.id);
    return clientService.uploadItem(req.clientId, req.id, item.id, file)
      .then((r) => { toast({ title: 'Document uploaded', description: item.label }); onChanged?.(r); })
      .catch(fail('Upload failed')).finally(() => setBusyItem(null));
  };
  return { busyItem, toggle, upload };
};
